import React from "react";
import { createRoot } from "react-dom/client";
import { Provider, useDispatch, useSelector } from "react-redux";
import { WindowService } from "./windowService";
import { getStore } from "./store";
import root from "./modules/root";
import { WindowServiceStore } from "./types";
import { DevToolsContainer } from "../common/DevTools";
import { System } from "../../../common/system";
import "../common/services.css";
import "../../../ui/assets/css/finsemble.css";

const WindowEventToggle = () => {
	const dispatch = useDispatch();
	const state: WindowServiceStore = useSelector((currentState: any) => currentState);
	const currentlyQuashing = state.root.quashedActions.includes("main/windowEvent");

	const action = currentlyQuashing ? "Show high frequency events" : "Hide high frequency events";

	const toggleWindowEvents = () => {
		dispatch(root.actions.quashActions(currentlyQuashing ? [] : ["main/windowEvent", "main/dockingOperation"]));
	};

	return <button onClick={toggleWindowEvents}>{action}</button>;
};

const WindowServiceUI = () => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const blah = 0;

	return (
		<Provider store={getStore()}>
			<WindowEventToggle />
			<div className="devTools">
				<DevToolsContainer
					windowVisible={root.actions.windowVisible}
					field={"finsemble.services.interopService.visible"}
				/>
			</div>
		</Provider>
	);
};

const main = async () => {
	// Sets the window to hide rather than close (hideOnClose) when the end user closes from the window frame
	const finWindow = System.Window.getCurrent();
	finWindow.addEventListener("close-requested", () => {
		finWindow.hide();
	});
};

main();

const container = document.getElementsByTagName("div")[0];
createRoot(container).render(<WindowServiceUI />);

// This line is necessary for the service to start, otherwise webpack thinks it's not being used and doesn't run the file InteropService.ts
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const windowService = WindowService;
